<ng-template #serviceNavTileInner>
  @if (expandedCard) {
    <span class="service-nav-tile__head">
      @if (busy) {
        <span class="tile-icon service-nav-tile__icon-spinner" aria-hidden="true">
          <ion-spinner name="crescent"></ion-spinner>
        </span>
      } @else {
        <ion-icon class="tile-icon" [name]="icon" aria-hidden="true"></ion-icon>
      }
      <span class="tile-label">
        @if (labelStrong) {
          <strong>{{ label }}</strong>
        } @else {
          {{ label }}
        }
      </span>
    </span>
    <div class="service-nav-tile__body">
      <ng-content />
    </div>
  } @else {
    <span class="service-nav-tile__inner">
      @if (busy) {
        <span class="tile-icon service-nav-tile__icon-spinner" aria-hidden="true">
          <ion-spinner name="crescent"></ion-spinner>
        </span>
      } @else {
        <ion-icon class="tile-icon" [name]="icon" aria-hidden="true"></ion-icon>
      }
      <span class="tile-label">
        @if (labelStrong) {
          <strong>{{ label }}</strong>
        } @else {
          {{ label }}
        }
      </span>
    </span>
  }
</ng-template>

@if (disabled) {
  <span
    class="service-tile service-nav-tile__anchor service-nav-tile__anchor--disabled disabled"
    [class.service-nav-tile__anchor--expanded]="expandedCard"
    [class.service-nav-tile__anchor--theme-primary]="themePrimary"
    aria-disabled="true"
    [attr.aria-label]="label"
  >
    <ng-container *ngTemplateOutlet="serviceNavTileInner" />
  </span>
} @else {
  <a
    class="service-tile service-nav-tile__anchor"
    [class.service-nav-tile__anchor--expanded]="expandedCard"
    [class.service-nav-tile__anchor--theme-primary]="themePrimary"
    [class.service-tile--navigating]="busy"
    [attr.aria-busy]="busy"
    [href]="route"
    (click)="onClick($event)"
  >
    <ng-container *ngTemplateOutlet="serviceNavTileInner" />
  </a>
}
